module.exports = __webpack_public_path__ + "images/locator/marker_inactive-12c950ae.svg";